import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getOs(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}os/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function addOs(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}os/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getByOs(id) {
    const { env } = getApiUrls();
    return axios.get(`${env}os/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function updateOs(payload) {
    const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}os/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}